var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.019,
    height: 11.375,
    viewBox: "0 0 13.019 11.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "\\uE813",
    d: "M11.629-9.75a3.3,3.3,0,0,0-1.65-.762,3.9,3.9,0,0,0-1.866.152,4.027,4.027,0,0,0-1.612.99,4.027,4.027,0,0,0-1.612-.99,3.9,3.9,0,0,0-1.866-.152,3.3,3.3,0,0,0-1.65.762A3.788,3.788,0,0,0,.152-7.871,3.559,3.559,0,0,0,.127-5.853a3.946,3.946,0,0,0,.965,1.739L5.535.406A1.318,1.318,0,0,0,6.5.813,1.318,1.318,0,0,0,7.465.406l4.443-4.52a3.946,3.946,0,0,0,.965-1.739,3.717,3.717,0,0,0,0-2.019A3.957,3.957,0,0,0,11.629-9.75Zm-.584,4.773L6.576-.457q-.076.1-.152,0L1.955-4.977a2.727,2.727,0,0,1-.647-1.181A2.482,2.482,0,0,1,1.32-7.541a2.508,2.508,0,0,1,.838-1.27A2.347,2.347,0,0,1,3.9-9.344a2.583,2.583,0,0,1,1.714.813l.889.889.889-.889A2.583,2.583,0,0,1,9.1-9.344a2.347,2.347,0,0,1,1.739.533,2.508,2.508,0,0,1,.838,1.27,2.482,2.482,0,0,1,.013,1.384A2.727,2.727,0,0,1,11.045-4.977Z",
    transform: "translate(0.007 10.563)",
    fill: "#ff6d6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavOff);
export default __webpack_public_path__ + "static/media/icon-fav-off.c2c2d803bb70be1d4dcee1334d583322.svg";
export { ForwardRef as ReactComponent };